import { render, staticRenderFns } from "./BModal.vue?vue&type=template&id=b9bc7e3c&scoped=true&"
import script from "./BModal.vue?vue&type=script&lang=js&"
export * from "./BModal.vue?vue&type=script&lang=js&"
import style0 from "./BModal.vue?vue&type=style&index=0&id=b9bc7e3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9bc7e3c",
  null
  
)

export default component.exports